import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { EmployeeConfigMaster } from '../../../models/config/EmployeeConfigMaster';
import { ResponseList } from '../../../models/common/Response';

export type UseEmployeeConfigMasterProps = {
    enabled?: boolean;
    sid?: string;
    id?: string;
    roleAccess?: string;
};

export const useEmployeeConfigMaster = (
    props?: UseEmployeeConfigMasterProps
) => {
    const { enabled, sid, id, roleAccess } = props || {};

    return useQuery({
        enabled,
        queryKey: ['employee-config-master', { sid, id, roleAccess }],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');

            return axios.get<ResponseList<EmployeeConfigMaster>>(
                '/v1/configuration/lis/employee',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    params: {
                        sid,
                        id,
                        role_access: roleAccess,
                    },
                }
            );
        },
        select: (response) => response.data.result_list,
        retry: 1,
        refetchOnWindowFocus: false,
    });
};
